import React from "react";
import classnames from "classnames";

import "./index.scss";

export interface PanelProps {
  busy?: boolean;
  children: React.ReactNode;
  className?: string;
}

const Panel: React.FC<PanelProps> = (props) => (
  <div className={classnames("panel", { "panel_is-busy": props.busy }, props.className)}>{props.children}</div>
);

export default Panel;
